const initialState = {
  data: {
    emailVerify: 'none',
  },
};

export default initialState;
